module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip2-099d66df6d41c69ee6357e1de014f824.png";